import { DataGrid, DataGridProps } from "@mui/x-data-grid"
import React from "react"

const ReportsTable = (props: DataGridProps<any> & React.RefAttributes<HTMLDivElement> & { fixedHeight?: boolean}) => {

    const getHeight = () => {
        const slotHeight = props.slots ? 40 : 0 ;
        const headerFooterHeight = slotHeight + ( props.hideFooter === false ?  110 : 65 ) 
        const rowsLength = props.rows.length
        if(rowsLength === 0) return 150
        if( props.fixedHeight ) return rowsLength * 52 + headerFooterHeight
        else return rowsLength * 52 + headerFooterHeight
    }

    return <div style={{height:getHeight() + 'px', maxHeight: props.fixedHeight ? "450px" : "none" ,overflow:'auto', width:'100%', position:'relative'}}>
        <div style={{position:'absolute', width:'100%', height:'100%'  }}>

        <DataGrid
            hideFooter
            sx={{
                ".MuiDataGrid-columnHeaders": { background: '#e4cca2;', borderRadius: '0' }, border: 'none', borderRadius: '0'
            }}
            {...props}
            />
            </div>
    </div>
}

export default ReportsTable